// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RPHT","col":"styles_col__2-480"};